export default "__VITE_ASSET__BL6d2axS__"